import { Decoder, string } from 'io-ts/lib/Decoder';

import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const Timezone = iotsUtils.fromList(constants.time.timezone.tzIdentifiers);

type UnsafeTimezoneType = (typeof constants.time.timezone.tzIdentifiers)[number] | (string & {});

export const UnsafeTimezone = string as Decoder<unknown, UnsafeTimezoneType>;
